module.exports = __webpack_public_path__ + "static/media/12_Jasper.23292bcd.png";